import { useTranslation } from "@next-platform/client-common-core";
import { CharacterCardActions, IconVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";
import { useNavigate } from "react-router-dom";

import CharacterCard from "@/components/Character/CharacterCard/variants";
import { ROUTES } from "@/constants";
import { HitDropdownActions } from "@/types/hits";
import { getMyChatbotDropdownActionLabels } from "@/utils";

import { CharacterCardData } from "../../types";

interface IMyChatbotCardProps {
  characterData: CharacterCardData;
  onAction: (action: CharacterCardActions, characterId: string) => void;
  onDelete: (characterId: string) => void;
  hasPermissionToDelete?: boolean;
  centeredElementIds: string[];
  setElementRef: (id: string, el: HTMLElement | null) => void;
}

const MyChatbotCard = ({
  characterData,
  onAction,
  onDelete,
  hasPermissionToDelete = true,
  centeredElementIds,
  setElementRef,
}: IMyChatbotCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const characterId = characterData?.characterId;
  const chatbotActionLabels = getMyChatbotDropdownActionLabels(t);

  const dropdownActions: HitDropdownActions[] = [
    {
      label: chatbotActionLabels.edit,
      icon: IconVariants.EDIT,
      onPress: () => navigate(`${ROUTES.editChatbot}/${characterId}`),
    },
    {
      label: chatbotActionLabels.delete,
      icon: IconVariants.TRASH,
      onPress: () => onDelete(characterId),
      isDisabled: !hasPermissionToDelete,
      isHidden: !hasPermissionToDelete,
      className: "text-red-9",
    },
    {
      label: chatbotActionLabels.report,
      icon: IconVariants.FLAG,
      onPress: () => navigate(`${ROUTES.report}/${characterId}`),
    },
  ];

  return (
    <div ref={(el) => setElementRef(characterId, el)}>
      <CharacterCard
        characterInfo={characterData}
        characterCardActionsHandler={onAction}
        characterCardActionsState={characterData?.characterActionsState}
        atCenter={centeredElementIds.includes(characterId)}
        variant={characterData?.characterCardVariant}
        dropdownMenuActions={dropdownActions}
      />
    </div>
  );
};

export default MyChatbotCard;
